/** Keep a single GTM bootstrap on the site's shared dataLayer, including Stape. */
function loadGtm(window, document, containerId, recordDiagnostic) {
    const source = 'bootstrap';
    const dataLayer = window.dataLayer;
    const scripts = Array.from(document.getElementsByTagName('script'));
    const hasStarted = Array.isArray(dataLayer) && dataLayer.some(entry =>
        entry && entry.event === 'gtm.js' && entry['gtm.start'] !== undefined);

    function isLoaded() {
        return Boolean(window.google_tag_manager && window.google_tag_manager[containerId]);
    }

    function loaderUrl(script) {
        try {
            return new URL(script.src, window.location.href);
        } catch (error) {
            return null;
        }
    }

    const existingScript = scripts.find(script => {
        const url = loaderUrl(script);
        if (!url) return false;
        const isSiteProxy = url.origin === window.location.origin && url.pathname.startsWith('/metrics/');
        const isGoogle = url.hostname === 'www.googletagmanager.com';
        const isSameDataLayer = (url.searchParams.get('l') || 'dataLayer') === 'dataLayer';
        if ((isSiteProxy || isGoogle) && url.pathname.endsWith('/gtm.js') && isSameDataLayer) {
            return url.searchParams.get('id') === containerId;
        }
        // Stape's opaque Custom Loader has no public container ID in its URL.
        // Its earlier gtm.start on this dataLayer establishes loader ownership.
        return hasStarted && isSiteProxy && url.pathname.endsWith('.js') && url.searchParams.has('btfib');
    });

    if (isLoaded()) {
        recordDiagnostic('gtm_loaded', { source: 'external_loader' });
        return;
    }

    if (existingScript || hasStarted) {
        recordDiagnostic('gtm_reused', { source: 'external_loader' });
        if (existingScript) {
            existingScript.addEventListener('load', function () {
                recordDiagnostic('gtm_loaded', { source: 'external_loader' });
            }, { once: true });
            existingScript.addEventListener('error', function () {
                recordDiagnostic('gtm_load_error', { source: 'external_loader' });
            }, { once: true });
        }
        return;
    }

    dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://krakowdirect.com/metrics/gtm.js?id=' + containerId;
    script.addEventListener('load', function () {
        recordDiagnostic('gtm_loaded', { source });
    }, { once: true });
    script.addEventListener('error', function () {
        recordDiagnostic('gtm_load_error', { source });
    }, { once: true });
    recordDiagnostic('gtm_requested', { source });
    if (scripts[0]) {
        scripts[0].parentNode.insertBefore(script, scripts[0]);
    } else {
        document.head.appendChild(script);
    }
}

module.exports = { loadGtm };
